<script setup>
import { useLanguageStore } from "@/stores/languageStore.js";

const languageStore = useLanguageStore();
defineProps({
  open: { type: Boolean, default: false },
  src: { type: String, default: "" },
  title: { type: String, default: "" }
});
const emit = defineEmits(["close"]);
</script>

<template>
  <Teleport to="body">
    <div v-if="open" class="original-viewer" @click.self="emit('close')">
      <div class="original-viewer-panel">
        <div class="original-viewer-header">
          <strong>{{ title || languageStore.t("originalImageTitle") }}</strong>
          <button type="button" @click="emit('close')">×</button>
        </div>
        <div class="original-viewer-body">
          <img v-if="src" :src="src" :alt="languageStore.t('originalImageTitle')" draggable="false" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.original-viewer {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgba(0, 5, 14, .82);
  backdrop-filter: blur(10px);
}
.original-viewer-panel {
  width: min(94vw, 860px);
  max-height: 92dvh;
  overflow: hidden;
  border: 1px solid rgba(82,246,232,.52);
  border-radius: 18px;
  background: #04111d;
  box-shadow: 0 24px 80px rgba(0,0,0,.6);
}
.original-viewer-header {
  min-height: 48px;
  padding: 0 12px 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid rgba(82,246,232,.18);
}
.original-viewer-header strong { color: #eafffd; }
.original-viewer-header button {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background: rgba(255,255,255,.08);
  font-size: 24px;
}
.original-viewer-body {
  display: grid;
  place-items: center;
  padding: 14px;
  max-height: calc(92dvh - 50px);
  overflow: auto;
  background: #010812;
}
.original-viewer-body img {
  display: block;
  max-width: 100%;
  max-height: calc(92dvh - 82px);
  object-fit: contain;
}
</style>
